import type { RecordEntry } from "../localRecords.ts";

export function RecordStatus({
  state,
  retry,
}: {
  state: RecordEntry & { changed: boolean; validation: string | null };
  retry: () => void;
}) {
  return (
    <div className="mt-2 text-xs" aria-live="polite">
      <p className="text-body dark:text-bodydark">
        {state.saving
          ? "Записване..."
          : state.loading
          ? "Търсене..."
          : state.loaded && !state.error
          ? state.changed
            ? state.record
              ? "Има незаписани промени."
              : "Няма запазени данни. Натиснете „Запиши“."
            : "Данните съвпадат."
          : ""}
      </p>
      {state.validation && !state.loading && (
        <p className="text-warning">{state.validation}</p>
      )}
      {state.error && (
        <div role="alert" className="mt-1 text-[#AA2808]">
          <p>{state.error}</p>
          <button
            type="button"
            onClick={retry}
            disabled={state.loading || state.saving}
            className="mt-1 underline"
          >
            Провери отново
          </button>
        </div>
      )}
    </div>
  );
}
